// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg width=15 height=15 viewBox=\"0 0 15 15\"> <g id=_4.6-Hotspot-info---menu-_inactive_ data-name=4.6-Hotspot-info---menu-(inactive) transform=\"translate(-20 -330)\"> <circle id=Oval cx=7.5 cy=7.5 r=7.5 transform=\"translate(20 330)\" fill=#f4a896 /> </g> </svg> ";
// Exports
module.exports = code;